import * as Yup from 'yup';
import { VIN_REGEX } from 'features/shared/constants/regex';

const addVehicleSchema = Yup.object({
  PlateNumber: Yup.string().nullable().required('Plate number is required'),
  PlateState: Yup.string().nullable().required('Plate state is required'),
  VIN: Yup.string().nullable().matches(VIN_REGEX, {
    message:
      'Enter a 17-character VIN without I, O, or Q. The 9th character must be a digit or X, and the last 6 must be digits.',
    excludeEmptyString: true,
  }),
});

export default addVehicleSchema;
